export const DEPARTAMENTO_ROL = {
  TRABAJADOR: 1,
  RESPONSABLE: 2,
} as const

export type DepartamentoRolType =
  (typeof DEPARTAMENTO_ROL)[keyof typeof DEPARTAMENTO_ROL]
